module.exports = __webpack_public_path__ + "static/media/amnesty-decoder-2.276e5381.png";